<template>
    <footer class="footer">
        <div class="wp">
            <div class="left">
                <div class="link">
                    <div class="item" v-for="(item,index) in nav" :key="index">
                      {{ $t('footer.' + item.key) }}
                    </div>
                </div>
                <div class="copyright">
                    Copyright © 2009-2098 www.meituodata.com All Rights Reserved.
                    <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备20027945号-1</a>
                </div>
            </div>
            <div class="right">
                <div class="txt">
                    <p>{{ $t('footer.phone') }}</p>
                    <p>{{ $t('footer.address') }}</p>
                </div>
                <div class="media">
                    <a href="">
                        <img src="@/assets/images/qq.jpg" alt="">
                    </a>
                    <a href="">
                        <img src="@/assets/images/wx.jpg" alt="">
                        <span class="qr">
                            <img src="@/assets/images/qr.gif" alt="">
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    data() {
        return {
          nav: [
            { key: 'about', path: '/about' },
            { key: 'philosophy', path: '/about' },
            { key: 'contact', path: '/contact' },
            { key: 'careers', path: '/join' }
          ]
        }
    },
    mounted() {

    },
    methods: {},

}

</script>


<style scoped lang="scss">
.footer {
    padding: 20px 0 40px;
    border-top: 1px solid #eee;
    .wp {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            .link {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .item {
                    cursor: pointer;
                    font-size: 14px;
                    color: #666666;
                }
                .item:hover{
                    color: #10aac2;
                }
                .item+.item{
                    padding-left: 10px;
                    margin-left: 10px;
                    border-left: 1px solid #e5e5e5;
                }
            }
            .copyright{
                font-size: 14px;
                color: #666666;
                a:hover{
                    color: #10aac2;
                }
            }
        }
        .right{
            display: flex;
            align-items: center;
            .txt{
                font-size: 14px;
                color: #666666;
                p+p{
                    margin-top: 20px;
                }

                margin-right: 40px;
            }
            .media{
                display: flex;
                align-items: center;
                a+a{
                    margin-left: 20px;
                }
                a{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    border: 1px solid #000;
                    img{
                        width: 16px;
                    }
                    .qr{
                        position: absolute;
                        left: 50%;
                        z-index: 80;
                        bottom: 120%;
                        width: 100px;
                        height: 100px;
                        margin-left: -50px;
                        opacity: 0;
                        pointer-events: none;
                        img{
                            display: block;width: 100%;height: 100%;
                        }
                    }
                }
                a:hover{
                    .qr{
                        opacity: 1;
                        pointer-events: auto;
                    }
                }
            }
        }
    }
}
</style>
